function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVgcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "28.013624mm",
    height: "46.349533mm",
    viewBox: "0 0 28.013624 46.349533",
    id: "svg877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-107.70152,-103.82524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1450",
    transform: "matrix(0.03527778,0,0,-0.03527778,103.70351,154.17497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 177.469,172.77 c 7.972,-2.571 16.804,-3.668 23.672,-3.668 11.281,0 19.5,4.898 25.015,12.257 5.516,7.243 8.223,16.93 8.223,26.61 0,9.691 -2.582,19.14 -7.727,26.371 -5.156,7.238 -12.879,12.019 -23.062,12.019 -8.832,0 -18.645,-3.187 -26.121,-7.968 z m -4.422,149.019 h 4.422 v -58.617 c 9.191,6.5 19.129,10.789 32.379,10.789 18.269,0 31.882,-7.359 40.84,-18.641 8.953,-11.289 13.363,-26.488 13.363,-42.191 0,-20 -5.391,-37.777 -16.059,-50.66 -10.797,-12.879 -26.617,-20.731 -47.594,-20.731 -7.851,0 -16.918,1.102 -25.996,3.071 -9.082,1.961 -18.281,4.781 -25.636,7.851 v 164.231 l 24.281,4.898",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 363.215,239.859 c -7.238,4.422 -14.348,6.379 -21.586,6.379 -9.316,0 -17.91,-3.429 -25.637,-9.316 V 144.199 H 287.293 V 271.5 h 24.289 l 2.945,-10.422 c 8.828,7.481 19.625,12.883 32.379,12.883 3.43,0 8.211,-0.25 12.879,-1.102 4.66,-0.859 9.195,-2.089 12.508,-3.929 l -9.078,-29.071",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 477.848,144.199 -2.946,9.93 c -11.773,-7.848 -26.242,-12.391 -40.476,-12.391 -12.145,0 -23.793,3.313 -32.254,10.684 -8.461,7.348 -13.984,18.75 -13.984,34.578 v 84.5 h 28.703 v -76.031 c 0,-9.449 3.429,-15.949 8.707,-20.117 5.277,-4.18 12.629,-6.141 20.117,-6.141 9.812,0 19.863,3.07 27.715,7.848 V 271.5 h 28.699 V 144.199 h -24.281",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 523.281,178.051 c 3.567,-1.961 8.461,-4.051 13.989,-5.891 5.39,-1.84 11.527,-3.058 17.535,-3.058 5.277,0 10.422,0.98 14.472,3.296 3.922,2.34 6.629,6.012 6.629,11.543 0,8.207 -6.011,11.891 -13.859,14.829 -4.051,1.48 -8.348,2.949 -12.879,4.3 -9.328,2.692 -17.539,7.481 -22.816,15.942 -2.696,4.179 -4.051,9.82 -4.051,17.047 0,13.371 5.277,22.941 13.367,29.07 8.098,6.133 19.016,8.832 30.664,8.832 9.813,0 20.852,-1.961 28.332,-4.781 v -25.758 l -1.469,-1.102 c -6.867,3.309 -13.613,5.149 -21.957,5.149 -5.39,0 -10.422,-0.86 -14.097,-2.699 -3.688,-1.84 -6.137,-4.661 -6.137,-8.59 0,-6.008 5.887,-9.071 13.738,-11.899 3.926,-1.34 8.211,-2.82 12.754,-4.41 9.195,-3.191 17.289,-8.582 22.57,-17.66 2.571,-4.531 3.922,-10.551 3.922,-17.91 0,-14.719 -5.886,-25.391 -14.965,-32.25 -9.078,-7 -21.339,-10.313 -33.968,-10.313 -12.758,0 -24.047,3.192 -32.754,8.711 v 26.86 l 0.98,0.742",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 615.543,178.051 c 3.555,-1.961 8.469,-4.051 13.984,-5.891 5.391,-1.84 11.528,-3.058 17.539,-3.058 5.278,0 10.422,0.98 14.469,3.296 3.926,2.34 6.621,6.012 6.621,11.543 0,8.207 -6.004,11.891 -13.851,14.829 -4.047,1.48 -8.344,2.949 -12.879,4.3 -9.328,2.692 -17.539,7.481 -22.817,15.942 -2.695,4.179 -4.046,9.82 -4.046,17.047 0,13.371 5.277,22.941 13.375,29.07 8.085,6.133 19.003,8.832 30.656,8.832 9.808,0 20.851,-1.961 28.328,-4.781 v -25.758 l -1.469,-1.102 c -6.867,3.309 -13.609,5.149 -21.957,5.149 -5.391,0 -10.422,-0.86 -14.098,-2.699 -3.687,-1.84 -6.132,-4.661 -6.132,-8.59 0,-6.008 5.886,-9.071 13.734,-11.899 3.926,-1.34 8.223,-2.82 12.758,-4.41 9.199,-3.191 17.289,-8.582 22.566,-17.66 2.571,-4.531 3.926,-10.551 3.926,-17.91 0,-14.719 -5.891,-25.391 -14.969,-32.25 -9.078,-7 -21.336,-10.313 -33.968,-10.313 -12.754,0 -24.043,3.192 -32.75,8.711 v 26.86 l 0.98,0.742",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 791.938,219.871 c -0.61,9.32 -3.926,15.949 -8.336,20.359 -4.418,4.301 -10.059,6.129 -15.575,6.129 -5.886,0 -11.898,-1.961 -16.804,-6.25 -5.032,-4.418 -8.832,-11.039 -10.668,-20.238 z m 19.746,-42.68 v -27.839 c -11.278,-5.532 -25.262,-7.614 -36.18,-7.614 -17.66,0 -33.969,5.524 -45.992,16.442 -12.024,10.922 -19.625,27.601 -19.625,49.672 0,21.457 7.117,37.898 17.91,49.179 10.672,11.168 25.016,16.93 39.371,16.93 4.043,0 11.281,-0.492 18.77,-3.07 7.476,-2.571 15.699,-7.481 21.824,-15.942 6.133,-8.461 10.429,-20.98 10.429,-38.64 V 197.18 h -77.277 c 2.336,-10.309 7.613,-17.289 14.481,-21.711 6.746,-4.41 14.957,-6.258 23.175,-6.258 10.793,0 22.2,3.07 32.012,8.348 l 1.102,-0.368",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 871.98,321.789 V 144.199 H 843.277 V 319.34 l 25.02,2.449 h 3.683",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 397.207,965.219 c 30.121,39.531 78.266,58.511 127.793,58.511 144.715,0 184.27,-113.207 184.27,-191.292 v -235.25 c 3.195,-45.489 28.132,-69.778 65.335,-83.047 64.637,66.418 104.465,157.101 104.465,257.097 0,203.625 -165.07,368.702 -368.695,368.702 -91.914,0 -175.965,-33.64 -240.531,-89.28 67.859,-5.32 111.453,-49.18 127.363,-85.441",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 624.277,597.188 v 235.23 c 0,61.617 -48.316,106.449 -103.707,106.449 -54.148,0 -105.769,-43.14 -105.769,-106.449 V 612.621 h -0.02 c -0.105,-23.34 -19.051,-42.254 -42.441,-42.254 -23.309,0 -42.203,18.805 -42.434,42.082 l -0.707,283.93 c -5.113,72.559 -67.004,89.965 -117.293,91.32 -44.164,-60.789 -70.23,-135.574 -70.23,-216.461 0,-203.625 165.074,-368.699 368.699,-368.699 70.09,0 135.613,19.563 191.41,53.52 -74.855,48.171 -77.508,141.129 -77.508,141.129",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 229.246,1273.08 c 3.496,-1.93 8.328,-3.99 13.766,-5.79 5.308,-1.82 11.347,-3.02 17.265,-3.02 5.188,0 10.258,0.96 14.243,3.26 3.867,2.29 6.519,5.92 6.519,11.35 0,8.09 -5.918,11.71 -13.644,14.6 -3.985,1.46 -8.207,2.9 -12.68,4.23 -9.172,2.66 -17.266,7.37 -22.449,15.69 -2.664,4.11 -3.989,9.66 -3.989,16.79 0,13.16 5.188,22.58 13.161,28.61 7.968,6.04 18.714,8.7 30.183,8.7 9.66,0 20.531,-1.94 27.891,-4.71 v -25.35 l -1.442,-1.1 c -6.761,3.27 -13.41,5.08 -21.617,5.08 -5.316,0 -10.258,-0.85 -13.887,-2.66 -3.621,-1.81 -6.031,-4.58 -6.031,-8.45 0,-5.92 5.793,-8.93 13.524,-11.71 3.863,-1.33 8.082,-2.78 12.554,-4.34 9.051,-3.15 17.024,-8.46 22.215,-17.39 2.535,-4.47 3.867,-10.39 3.867,-17.63 0,-14.5 -5.797,-24.99 -14.734,-31.76 -8.938,-6.87 -21.008,-10.14 -33.449,-10.14 -12.559,0 -23.66,3.14 -32.235,8.57 v 26.45 l 0.969,0.72",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 356.215,1268.61 c 7.726,-2.89 16.176,-4.34 23.305,-4.34 11.113,0 19.195,4.82 24.632,12.07 5.43,7.12 8.086,16.67 8.086,26.21 0,9.53 -2.535,18.83 -7.605,25.94 -5.074,7.13 -12.68,11.84 -22.695,11.84 -8.696,0 -18.352,-3.13 -25.723,-7.85 z m -4.344,96.48 2.656,-9.43 c 9.536,7.13 19.684,11.84 33.563,11.84 17.996,0 31.394,-7.24 40.211,-18.36 8.808,-11.1 13.156,-26.08 13.156,-41.53 0,-19.68 -5.316,-37.18 -15.82,-49.86 -10.625,-12.68 -26.199,-20.41 -46.84,-20.41 -6.883,0 -15.211,0.72 -22.582,3.51 v -56.39 h -28.254 v 180.63 h 23.91",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 487.344,1303.02 c 0,-10.5 2.773,-20.04 8.215,-27.04 5.429,-7.01 13.879,-11.47 25.113,-11.47 10.625,0 18.586,3.98 23.902,10.62 5.309,6.64 7.852,15.94 7.852,26.68 0,10.63 -2.543,20.29 -7.852,27.29 -5.437,7.01 -13.519,11.23 -24.633,11.23 -10.738,0 -18.953,-3.99 -24.382,-10.62 -5.442,-6.77 -8.215,-16.06 -8.215,-26.69 z m -28.856,-1.09 c 0,18.72 6.407,35.02 17.387,46.73 10.988,11.72 26.445,18.84 44.676,18.84 18.351,0 33.562,-7.12 44.187,-18.84 10.625,-11.71 16.664,-27.77 16.664,-45.99 0,-18.49 -6.281,-34.9 -17.152,-46.49 -10.859,-11.71 -26.434,-18.84 -44.789,-18.84 -18.352,0 -33.563,7.13 -44.188,18.72 -10.746,11.59 -16.785,27.89 -16.785,45.87",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 679.012,1333.93 c -7.125,4.34 -14.133,6.28 -21.25,6.28 -9.18,0 -17.629,-3.38 -25.235,-9.17 v -91.29 H 604.27 v 125.34 h 23.906 l 2.906,-10.27 c 8.684,7.37 19.316,12.68 31.867,12.68 3.383,0 8.094,-0.25 12.68,-1.08 4.594,-0.86 9.055,-2.06 12.32,-3.87 l -8.937,-28.62",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 712.055,1365.09 v 31.38 l 24.625,2.42 h 3.629 v -33.8 h 37.304 v -27.17 h -37.304 v -42.74 c 0,-9.19 0.234,-16.91 3.132,-22.22 2.774,-5.43 8.336,-8.45 18.594,-8.45 3.988,0 8.695,0.48 13.281,1.21 4.586,0.72 8.817,1.69 12.2,2.77 l 4.953,-26.44 c -4.231,-1.44 -10.27,-2.53 -16.43,-3.38 -6.273,-0.85 -12.672,-1.33 -17.387,-1.33 -12.07,0 -23.66,3.14 -32.23,10.87 -8.695,7.73 -14.367,19.92 -14.367,38.15 v 51.56 h -15.7 v 27.17 h 15.7",
    style: {
      fill: "#ba1c2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1478"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgcLogo);
export default __webpack_public_path__ + "static/media/vgc_logo.f4f54627c4e7d17cd35a76e8983cac81.svg";
export { ForwardRef as ReactComponent };